import actions from 'actions'

const defaultState = {
  isNewVenue: false,
  newVenue: null,
  newVenueOriginal: null,
  venueSearchResults: null,
  imageId: null,
  isUploadingImage: false,
  isValidatingImage: false,
  imagePreview: null,
  setupformId: null,
  tracked: false,
}

export default function setupformVouchersPage(state = defaultState, action) {
  switch (action.type) {
    case actions.SETUPFORM_VOUCHER_DELETED: {
      const modifiedSetupForms = {}
      modifiedSetupForms[action.setupformId] = { ...state.entities.setupforms[action.setupformId] }
      const indexToRemove = modifiedSetupForms[action.setupformId].instanceGroups.findIndex(
        group => group.id === action.instanceGroupId
      )
      if (indexToRemove >= 0) {
        modifiedSetupForms[action.setupformId].instanceGroups.splice(indexToRemove, 1)
      }

      return {
        ...state,
        entities: {
          ...state.entities,
          setupforms: {
            ...state.entities.setupforms,
            ...modifiedSetupForms
          }
        }
      }
    }
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/pages/setupform-vouchers-page/setupform-vouchers-page.js
 **/